import axios from "axios";
import get from "lodash/get";
import i18next from 'i18next';

import {
    askPasswordResetRequestFail,
    askPasswordResetRequestStart,
    askPasswordResetRequestSuccess,

    setNewPasswordRequestStart,
    setNewPasswordRequestSuccess,
    setNewPasswordRequestFail,

    registerRequestFail,
    registerRequestStart,
    registerRequestSuccess,

    sendAuthHSMRequestFail,
    sendAuthHSMRequestStart,
    sendAuthHSMRequestSuccess,

    sendCodeRequestFail,
    sendCodeRequestStart,
    sendCodeRequestSuccess,

    verifyCodeRequestFail,
    verifyCodeRequestStart,
    verifyCodeRequestSuccess,

    getMeRequestStart,
    getMeRequestSuccess,
    getMeRequestFail,

    retailCRMRegisterRequestFail,
    retailCRMRegisterRequestStart,
    retailCRMRegisterRequestSuccess,

    logInRequestStart,
    logInRequestSuccess,
    logInRequestFail,
} from '../actions/Auth'
import {eventsSetUserId} from "../Components/utils";
import {registerPushToken} from "./Users";
import {Toast} from "@capacitor/toast";
import {shopsRequestStart} from "../actions/Shops";


export const askPasswordReset = (email, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(askPasswordResetRequestStart(email));

        const data = {
            email,
        };

        instance.post('auth/ask_password_reset/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(askPasswordResetRequestSuccess(email, response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(askPasswordResetRequestFail(response.data.errors));
                    callback && callback(response.data.errors);
                }
            },
            error => {
                dispatch(askPasswordResetRequestFail({'common': 'errors.common.request_sent'}));
                callback && callback(get(error, 'response.data.errors'));
            },
        );
    }
};

export const askPasswordResetv2 = (email, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(askPasswordResetRequestStart(email));

        const data = {
            email,
        };

        instance.post('auth/ask_password_reset_v2/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(askPasswordResetRequestSuccess(email, response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(askPasswordResetRequestFail(response.data.errors));
                    callback && callback(response.data.errors);
                }
            },
            error => {
                dispatch(askPasswordResetRequestFail({'common': 'errors.common.request_sent'}));
                callback && callback(get(error, 'response.data.errors'));
            },
        );
    }
};

export const setNewPassword = (password, token, callbackSuccess, callbackError) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(setNewPasswordRequestStart(password, token));

        const data = {
            password,
            token,
        };

        instance.post('auth/password_reset/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(setNewPasswordRequestSuccess(password, token, response.data.result));
                    callbackSuccess && callbackSuccess();
                    Toast.show({
                        text: i18next.t('auth.reset_password.password_changed', 'Password changed')
                    });
                } else {
                    let err = response.data.errors;
                    dispatch(setNewPasswordRequestFail(err));
                    callbackError && callbackError();
                }
            },
            error => {
                dispatch(setNewPasswordRequestFail({'common': 'errors.common.request_sent'}))
                callbackError && callbackError();
            }
        );
    }
};

export const sendAuthHSM = (phone, lang_code, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_SERVICE_AUTH_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(sendAuthHSMRequestStart(phone));

        const data = {
            phone,
            lang_code,
        };

        instance.post('auth_hsm', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(sendAuthHSMRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(sendAuthHSMRequestFail(response.data.errors));
                }
            },
            error => dispatch(sendAuthHSMRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};

export const sendCode = (phone_number, lang_code, redirectTo) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(sendCodeRequestStart(phone_number));

        const data = {
            phone_number,
            lang_code,
        };

        instance.post('auth/send_code/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(sendCodeRequestSuccess(response.data.result));
                    if (redirectTo) {
                        window.location.href = redirectTo;
                    }
                } else {
                    dispatch(sendCodeRequestFail(response.data.errors));
                }
            },
            error => dispatch(sendCodeRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};

export const verifyCode = (phone_number, code, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(verifyCodeRequestStart(phone_number, code));

        const data = {
            phone_number: phone_number,
            code: code,
        };

        instance.post('auth/verify_code/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(verifyCodeRequestSuccess(response.data.result, phone_number, code));
                    callback && callback(response.data.result);
                } else {
                    dispatch(verifyCodeRequestFail(response.data.errors));
                }
            },
            error => dispatch(verifyCodeRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};

export const register = (
    email,
    phone_number,
    code,
    password,
    passwordrep,
    check,
    referral_code,
    lang_code,
    callback,
) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(registerRequestStart(email, phone_number, code, password, passwordrep, check, referral_code));

        const data = {
            email,
            phone_number,
            code,
            password,
            passwordrep,
            check,
            ref: referral_code,
            lang_code,
        };

        instance.post('auth/register/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(registerRequestSuccess(response.data.result.user.email));
                    callback && callback(response.data.result);
                } else {
                    dispatch(registerRequestFail(response.data.errors));
                }
            },
            error => dispatch(registerRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};


export const retailCRMRegister = (
    module_name,
    phone,
    retailcrm_url,
    retailcrm_api_key,
    code,
    callback,
) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_SERVICE_AUTH_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(retailCRMRegisterRequestStart(module_name, phone, retailcrm_url, retailcrm_api_key, code));

        const data = {
            module_name,
            phone,
            retailcrm_url,
            retailcrm_api_key,
            code,
        };

        instance.post('register_retailcrm', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(retailCRMRegisterRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(retailCRMRegisterRequestFail(response.data.errors));
                }
            },
            error => dispatch(retailCRMRegisterRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};

export const getMe = (authToken, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(getMeRequestStart(authToken));

        instance.get('auth/get_me_phone/').then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(getMeRequestSuccess(authToken, response.data.result.user));
                    callback && callback(response.data.result);
                    eventsSetUserId(response.data.result.user.id);
                    registerPushToken();
                } else {
                    dispatch(getMeRequestFail(response.data.errors));
                    callback && callback(response.data.errors);
                    Toast.show({
                        text: 'Login failed'
                    });
                }
            },
            error => {
                dispatch(getMeRequestFail(`Errors: ${get(error, 'response.data.errors')}`));
                callback && callback(get(error, 'response.data.errors'));
            },
        );
    };
};

export const logInRequestAuth = (email, password, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(logInRequestStart(email, password));

        instance.post('auth/login/', {email, password}).then(response => {
            if (response.data.status === 'ok') {
                eventsSetUserId(response.data.result.profile.id);
                dispatch(logInRequestSuccess(response.data.result.token, response.data.result.profile));
                registerPushToken();
                callback && callback(response.data.result);
            } else {
                dispatch(logInRequestFail(response.data.errors));
                callback && callback(response.data.errors);
                Toast.show({
                    text: 'Login failed'
                });
            }
        },
        error => {
            dispatch(logInRequestFail({'common': 'errors.common.request_sent'}));
            callback && callback(get(error, 'response.data.errors'));
        })
    }
};

export const acceptingAnInvite = (jwt_token, isAuthed) => {
    return function (dispatch) {


        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        instance.post('auth/obtain_operator_token_v2_mobile/', {jwt_token}).then(response => {
            if (response.data.status === 'ok') {
                Toast.show({
                    text: i18next.t('thunks.accepting_an_invite_success', 'Invitation successfully accepted')
                });
                if(isAuthed){
                    dispatch(shopsRequestStart('',true))
                }
            } else {
                Toast.show({
                    text: response.data.error
                });
            }
        },
        error => {
            Toast.show({
                text: i18next.t('errors.common.request_sent', 'Error sending request')
            });
        })
    }
};
